import React from "react";
import parse from "html-react-parser";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { HelperActions } from "./HelperActions.js";
import { useProfile } from "contexts/profileContext/profileContext.js";

import "./SubUserMobileTable.scss";
import "./SubUserTable.scss";

const SubUserMobileTable = ({
  currentPage,
  sizeNumber,
  setLoading,
  setSubUsers,
  setNumberOfUsers,
  fieldToOrder,
  orderAscending,
  tableData,
  loading,
}) => {
  const { setSelectedSubUser, getStatusFilter } = useProfile();
  const showRemovedUsers = getStatusFilter()?.includes("removed");

  const clickedOnUser = (subUser) => {
    setSelectedSubUser(subUser);
  };

  return (
    <>
      {loading ? (
        <div className="sub-user-loading">
          <LoadingImageElement />
        </div>
      ) : (
        <>
          {tableData.map((subUser) => {
            return showRemovedUsers ? (
              <div
                className="mobile-sub-user-container"
                key={subUser.RemovedUserEmail}
              >
                <div
                  className="mobile-open-user-details"
                  onClick={() => clickedOnUser(subUser)}
                >
                  <div className="mobile-sub-user-picture">
                    {subUser?.RemovedUserProfilePicture &&
                      parse(subUser.RemovedUserProfilePicture)}
                  </div>
                  <div className="mobile-sub-user-details-container">
                    <div className="mobile-sub-user-full-name">
                      {subUser.RemovedUserName}
                    </div>
                    <div className="mobile-sub-user-email">
                      {subUser.RemovedUserEmail}
                    </div>
                  </div>
                  <div className="mobile-sub-user-actions"></div>
                </div>
              </div>
            ) : (
              <div className="mobile-sub-user-container" key={subUser.Email}>
                <div
                  className="mobile-open-user-details"
                  onClick={() => clickedOnUser(subUser)}
                >
                  <div className="mobile-sub-user-picture">
                    {subUser?.ProfilePicture && parse(subUser.ProfilePicture)}
                  </div>
                  <div className="mobile-sub-user-details-container">
                    <div className="mobile-sub-user-full-name">
                      {subUser.FullName}
                    </div>
                    <div className="mobile-sub-user-email">{subUser.Email}</div>
                  </div>
                </div>
                <div className="mobile-sub-user-actions">
                  <HelperActions
                    details={subUser}
                    currentPage={currentPage}
                    sizeNumber={sizeNumber}
                    setLoading={setLoading}
                    setSubUsers={setSubUsers}
                    setNumberOfUsers={setNumberOfUsers}
                    fieldToOrder={fieldToOrder}
                    orderAscending={orderAscending}
                  />
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default SubUserMobileTable;
